import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalModule } from '@argalis-apps/angular-global';
import { ServicesModule } from '@argalis-apps/angular-services';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Routes, RouterModule } from '@angular/router';
import { CatalogRouting } from './catalog-routing';
import { FormPageComponent } from './components/form-page/form-page.component';
import { FormationOverviewCardComponent } from './components/formation-overview-card/formation-overview-card.component';
import { FicheFormationComponent } from './components/fiche-formation/fiche-formation.component';
import { FicheFormationEnteteComponent } from './components/fiche-formation-entete/fiche-formation-entete.component';
import { FicheFormationInscriptionComponent } from './components/fiche-formation-inscription/fiche-formation-inscription.component';
import { FicheFormationFocusComponent } from './components/fiche-formation-focus/fiche-formation-focus.component';
import { FicheFormationDetailComponent } from './components/fiche-formation-detail/fiche-formation-detail.component';
import { QuickSearchComponent } from './components/quick-search/quick-search.component';
import { SearchComponent } from './components/search/search.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { CatalogConfigService, CatalogConfigServiceOption } from './services/catalog-config/catalog-config.service';
import { CartModule } from '../cart/cart.module';

@NgModule({
  declarations: [
    SearchComponent,
    SearchResultComponent,
    FormPageComponent,
    FormationOverviewCardComponent,
    FicheFormationComponent,
    FicheFormationEnteteComponent,
    FicheFormationInscriptionComponent,
    FicheFormationFocusComponent,
    FicheFormationDetailComponent,
    QuickSearchComponent
  ],
  exports: [SearchComponent, SearchResultComponent, FormPageComponent, QuickSearchComponent],
  imports: [
    CartModule,
    CommonModule,
    RouterModule,
    GlobalModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    DatePickerModule,
    DropDownsModule,
    InputsModule,
    IntlModule,
    LayoutModule,
    ServicesModule
  ],
  providers: [CatalogConfigService]
})
export class CatalogModule {
  public static moduleRouting(config?: CatalogConfigServiceOption): Routes {
    return CatalogRouting;
  }
  public static forRoot(config?: CatalogConfigServiceOption): ModuleWithProviders<CatalogModule> {
    return {
      ngModule: CatalogModule,
      providers: [
        CatalogConfigService,
        {
          provide: CatalogConfigServiceOption,
          useValue: config
        }
      ]
    };
  }
}
